module.exports = __webpack_public_path__ + "img/icon-3.a051526a.svg";